module.exports = __webpack_public_path__ + "static/media/extract-banner.d657ff94.svg";